<div class="bg-topographic h-100">
    <nav class="topnav navbar navbar-expand-lg bg-white" #topNav>
        <div class="container-xxl" #navbarContainer>
            <div class="d-flex justify-content-between align-items-center w-100">
                <a class="ms-lg-10 ms-3" routerLink="/" aria-label="Tredder Logo"
                    ><div id="tredderLogo"><sbf-tredder-icons name="tredder-logo" height="100%" width="auto"></sbf-tredder-icons></div></a
                ><a class="d-flex justify-content-between align-items-center" [href]='"tel:" + tredderOverlandJournalPhoneNumberHref'
                    ><i-bs class="text-primary" name="telephone" width="1.5em" height="1.5em"></i-bs>
                    <div class="text-cyan-blue semi-bold ms-2 me-3">{{tredderOverlandJournalPhoneNumber}}</div></a
                >
            </div>
        </div>
    </nav>
    <div class="header-tredder-rig-wreck d-flex justify-content-end align-items-center">
        <div class="container-xxl px-md-10 px-md-5 px-3 py-lg-5 py-3">
            <div class="d-flex justify-content-start align-items-start flex-column flex-shrink-1">
                <div class="mb-3">
                    <div class="r-tredder-mid lh-plus text-white fw-600 d-block mb-3">Mods, Gear, Adventure:</div>
                    <div class="r-tredder-mid lh-plus text-secondary fw-600 d-block mb-3">Insured.</div>
                </div>
                <div class="r-text-lg3 lh-plus text-white mb-3">We created Tredder to protect the gear that makes your adventure vehicle unique.</div>
                <div class="r-text-lg3 lh-plus text-white mb-3">Chances are, your best modifications wouldn’t be covered if the worst happened while you’re off road.</div>
            </div>
        </div>
    </div>
    <div class="container-lg px-md-5 mt-3"><sbf-estimate [formOnly]="true" analyticsCategory="brand"></sbf-estimate></div>
</div>
